module.exports = __webpack_public_path__ + "img/DW365-247.1b1a9d49.jpg";